import _ from 'lodash';
import Note from './Note';
import withProbability from './lib/withProbability';
import keyCode from 'keycode';
import getScaleNotes from './get-scale-notes';
import Minibus from 'minibus';
import synth from './synths/steeldrum';
import mutateNote from './mutateNote';
import key from 'music-key';
import mutations from './mutations';
import keyboardPlayer from './keyboardPlayer';
import quantizeTime from './lib/quantizeTime';

import * as PatternGenerators from './patternGenerators';

export default class Programmer{
  constructor(Tone, userKey) {
    this.events = Minibus.create();
    this.key = userKey;
    this.octaveLength = key(userKey).length;
    this.Tone = Tone;
    this.history = [];
    this.mutations = mutations(this);
    this.segmentSpace = Tone.Time('8n').toSeconds();

    this.instruments = [
      {
        name: 'lead',
        synth: synth,
        notes: getScaleNotes(userKey, [3,4]),
        history: []
      }
    ]

    keyboardPlayer(this);
  }

  start() {
    this.loop();
  }

  loop = () => {
    this.playSequence(
     this.getNewPattern(true),
     this.loop
    )
  }

  playNote(note, verbose) {
    if (!note) return;
    if (!note.instrument) throw new Error('note has no instrument');

    note.play(verbose);
    this.history.push(note);
    this.events.emit('note', note);
  }

  playSequence(notes, callback, verbose) {
    let offset = '';

    // TODO: combine the offset?
    // TODO: Take the note start time in mind?
    // Maybe add an end time to the note?
    notes.forEach( note => {
      let duration;
      if (_.isArray(note)) {
        // For batches of notes, play them all with the same offset
        note.forEach(n => { n.delay(offset); this.playNote(n) });
        // console.log(note);
        // We're not looking for the Mean, but for the mode, for now, lets use first one
        duration = note[0].duration;
        // duration = _.mean(note.map(
        //   n => this.Tone.Time(n.duration).toSeconds() )
        // )

        // duration = this.Tone.Time(duration).toNotation();
      } else {
        note.delay(offset);
        this.playNote(note);
        duration = note.duration;
      }

      // debugger
      offset = quantizeTime(offset ? offset + '+'+ duration : duration)
    }, this);

    if (verbose) console.log(notes.map( n => n.getNoteValue()), notes);

    if (callback) {
      let lastNote = _.last(notes);
      if (_.isArray(lastNote)) lastNote = _.last(lastNote);

      const spaceMultiplier = Math.round( (1 + (Math.random() * 4)) );
      const spacing = this.segmentSpace * (
        withProbability(.15) ? spaceMultiplier : 1
      )

      if (spacing !== this.segmentSpace) console.log('🍹 Taking a rest');

      new this.Tone.Event( callback ).start(
       this.Tone.Time().add(offset).add(lastNote.duration).add(spacing).quantize('4n')
      )
    }
  }

  randomNote(instrument) {
    return new Note(
      Math.floor(Math.random() * (instrument.notes.length - 1)),
      instrument
    )
  }

  getNewPattern(verbose) {
    const patternName = _.sample(Object.keys(PatternGenerators));
    const patternGenerator = PatternGenerators[patternName];
    const pattern = this.mutatePattern(patternGenerator(this, this.instruments[0]));

    // if (verbose) console.log(patternName, pattern.map( n => (
    //   _.isArray(n) ? n.map(n => n.getNoteValue()) : n.getNoteValue()
    // ), pattern));
    if (verbose) (console.log(patternName, pattern))

    return pattern;
  }

  mutatePattern = pattern => pattern.map( n => mutateNote(n, this.mutations))

}



// WEBPACK FOOTER //
// ./src/newProgrammer.js